"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- FILTER MENU : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'FilterMenu',
  group: _definitionhelpers.groupNames.menus,
  props: {
    name: {
      type: 'string',
      default: 'filtermenu'
    },
    filters: {
      type: 'object',
      default: {
        ssps: {
          title: "SSP",
          icon: false,
          initialState: [],
          items: [{
            value: 'ADEX',
            text: 'ADEX'
          }, {
            value: 'GUMGUM',
            text: 'GUMUM'
          }, {
            value: 'SURVEY',
            text: 'SURVEY'
          }]
        },
        sspStatus: {
          title: "SSP Status",
          icon: false,
          initialState: [],
          items: [{
            value: 'INACTIVE',
            text: 'Inactive'
          }, {
            value: 'TESTING',
            text: 'Testing'
          }, {
            value: 'ACTIVE',
            text: 'Active'
          }]
        },
        adType: {
          title: "Ad Type",
          icon: false,
          initialState: [],
          items: [{
            value: 'DISPLAY',
            text: 'Display'
          }, {
            value: 'VIDEO',
            text: 'Video'
          }, {
            value: 'BOTH',
            text: 'Display and Video'
          }]
        }
      }
    },
    onApply: {
      type: 'function',
      default: function _default() {
        return console.log('apply filters');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    }
  }
};
exports.default = _default2;